export default {
    getInstallments: { method: 'get', url: 'emcadmin/installments' },
    postInstallments: { method: 'post', url: 'emcadmin/installments' },
    putInstallments: { method: 'put', url: 'emcadmin/installments/{id}' },
    deleteInstallments: { method: 'delete', url: 'emcadmin/installments/{id}' },
}
